import { Error } from '../error';

export const Page404 = () => (
  <Error errorTitle="404" errorMessage="Page Not Found" />
);
